import { type TaxMode } from '@webapp/modules/expense/business-logic/use-cases/ComputeExpenseLineItemTotals'
import {
  type ExpenseTaxSelectValue,
  isPresetTax,
} from '../types/ExpenseTaxSelectValue'

export interface ResolveTaxModeParams {
  taxType: ExpenseTaxSelectValue
  taxAmount: Nullable<number>
  customTaxPercentage: Nullable<number>
  isOverridden: boolean
}

export const resolveTaxMode = ({
  taxType,
  taxAmount,
  customTaxPercentage,
  isOverridden,
}: ResolveTaxModeParams): TaxMode => {
  // When the tax amount is override, treat the tax mode as a flat amount to be used in the totals
  // and ignore the calculation by percentage.
  if (isOverridden) {
    return { mode: 'dollar', amount: taxAmount ?? 0 }
  }
  if (isPresetTax(taxType)) {
    return { mode: 'custom', percentage: taxType.percentage }
  }
  if (taxType.id === '$') {
    return { mode: 'dollar', amount: taxAmount ?? 0 }
  }
  if (customTaxPercentage != null) {
    return { mode: 'percent', amount: customTaxPercentage }
  }

  // Defaults to "percent" mode when no source is set
  return { mode: 'percent', amount: taxAmount ?? 0 }
}
